import installConfig from './config';
import { SouthcnPlugins } from 'southcn-mobile-ui';
import { pcModalMap } from './modalDefined';

const {installNotify, installHttp, installBus, installStorage, installAlias, installStyle, installFilters, installModal, installUtil} = SouthcnPlugins;
const injection = {};

export default Object.assign(injection, {

    install (Vue) {
        installHttp(injection, Vue);
        installBus(injection, Vue);
        installConfig(injection, Vue);
        installStyle(injection, Vue);
        installFilters(injection, Vue);
        installModal(injection, Vue, pcModalMap);
        installNotify(injection, Vue);
        installStorage(injection, Vue);
        installAlias(injection, Vue);
        installUtil(injection, Vue, {
            url: function (c, a, args, flag) {
                let url, i, fi = true;
                let preUrl = window._CONFIG.APP_URL + '/hdjlpt/yjzj';
                if (window._CONFIG.env !== 'production') {
                    preUrl = '';
                }
                url = preUrl + '/' + c + '/' + a;
                if (flag) {
                    url = url + '/' + args.join('/');
                } else {
                    if (args) {
                        for (i in args) {
                            if (fi) {
                                fi = false;
                                url += '?' + i + '=' + encodeURIComponent(args[i]);
                            } else {
                                url += '&' + i + '=' + encodeURIComponent(args[i]);
                            }
                        }
                    }
                }
                return url;
            }
        });
        window.injection = injection;
    }

});
